import React, { FunctionComponent } from 'react'
import { SVGProps } from 'interfaces'

const SVG: FunctionComponent<SVGProps> = ({ className }) => (
    <svg width='100%' className={className} viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            opacity='0.3'
            d='M22.5469 17.4363L26.5255 20.4646C27.9397 18.6065 30.1231 17.5 32.4996 17.5C36.6417 17.5 39.9996 20.8579 39.9996 25C39.9996 29.1421 36.6417 32.5 32.4996 32.5C30.3777 32.5 28.4086 31.6209 26.9942 30.0933L23.3253 33.4902C25.6086 35.9563 28.8738 37.5 32.4996 37.5C39.4032 37.5 44.9996 31.9036 44.9996 25C44.9996 18.0964 39.4032 12.5 32.4996 12.5C28.4387 12.5 24.8302 14.4364 22.5469 17.4363Z'
            fill='#52BD95'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M17.5 37.5C10.5964 37.5 5 31.9036 5 25C5 18.0964 10.5964 12.5 17.5 12.5C24.4036 12.5 30 18.0964 30 25C30 31.9036 24.4036 37.5 17.5 37.5Z'
            fill='#0D1537'
        />
    </svg>
)

export default SVG
